/**
 * Detects the direction of a string of text
 *
 * @param text The string to detect the direction of
 * @returns {string} Either 'rtl' or 'ltr'
 */

export const getTextDirection = (text: string) => {
  const rtlRegex = /[\u0591-\u07FF]/;
  return rtlRegex.test(text) ? 'rtl' : 'ltr';
};
